import CelebrationBackSearchButtonClientOnly from '@/components/BackSearchButton/CelebrationBackSearchButton';
import ShareButton from '@/components/ShareButton';
import { Skeleton } from '@/components/Skeleton';

import './FullCruiseDetailsSkeleton.scss';

const Row = () => (
  <div className="PricedSailingCard MoreDatesSailingCard">
    <div className="startEndDate">
      <div>
        <Skeleton width="140px" />
      </div>
    </div>
    <div>
      <div className="priceAndArrow">
        <span className="price">
          <span className="priceFromLabel">
            <Skeleton inline width="20px" />
          </span>
          <span className="price">
            <Skeleton inline width="100px" />
          </span>
        </span>
      </div>
    </div>
  </div>
);

const FullCruiseDetailsSkeleton = ({ backHandler }: { backHandler: CallableFunction }) => {
  return (
    <div className="FullCruiseDetailsSkeleton">
      <div className="ItineraryDetailsMain">
        <section className="searchShare ItineraryDetails-container">
          <CelebrationBackSearchButtonClientOnly onClick={backHandler} />
        </section>

        <div className="ItineraryVideoMobile">
          <Skeleton containerClassName="ItineraryVideoMobile__skeleton" height="100%" width="100%" />
        </div>

        <div className="ItineraryDetails ItineraryDetails-container">
          <div className="ItineraryDetails__title" id="datesOverlayPackageTitle">
            <Skeleton width="100%" />
          </div>
          <div className="description">
            <div className="nightsShipName">
              <span className="shipIcon">
                <Skeleton inline width="30px" />
              </span>
              <span className="nightsShipNameText">
                <Skeleton inline width="400px" />
              </span>
            </div>
            <div className="tripTypePort">
              <span className="locationIcon">
                <Skeleton inline width="30px" />
              </span>
              <span className="tripTypePortText">
                <Skeleton inline width="300px" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="FullCruiseDetailsMain">
        <div className="FullCruiseDetailsLeft">
          <div className="ItineraryImageMoreDatesSection">
            <div className="ItineraryVideo">
              <Skeleton height="356px" width="100%" />
            </div>
          </div>

          <div className="FullCruisePortsOfCall">
            <div className="headingSubHeading">
              <div className="sailingHeading">
                <Skeleton width="400px" />
              </div>
              <div className="sailingSubHeading">
                <Skeleton width="100%" />
                <Skeleton width="100%" />
                <Skeleton width="100%" />
                <Skeleton width="340px" />
              </div>
            </div>

            <div className="FullCruiseImage">
              <Skeleton height="500px" width="100%" />
            </div>

            <div className="portsOfCalls">
              <div className="sailingNameShipName">
                <div className="sailingNameDuration">
                  <span>
                    <Skeleton inDarkBg inline width="400px" />
                  </span>
                </div>
                <div className="sailingShipName">
                  <Skeleton inDarkBg width="300px" />
                </div>
              </div>
            </div>

            <div className="VoyageExperience">
              <div className="experinceHeading">
                <Skeleton inline width="450px" />
              </div>
              <div className="voyageExperienceRows">
                {[{}, {}, {}].map((usp, index) => (
                  <div className="voyageExperienceRow" key={index}>
                    <div className="experienceImage">
                      {' '}
                      <Skeleton circle height="80px" width="80px" />
                    </div>
                    <div className="experienceTextContent">
                      <p className="experienceName">
                        <Skeleton width="240px" />
                      </p>
                      <p className="experienceDescription">
                        <Skeleton width="300px" />
                        <Skeleton width="300px" />
                        <Skeleton width="250px" />
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="ActivitiesImageDescription">
            <Skeleton height="500px" width="100%" />
            <div className="ActivitiesTextContent">
              <div className="ActivitiesHeading">
                <Skeleton width="300px" />
              </div>
              <div className="ActivitiesDescription">
                <Skeleton width="100%" />
                <Skeleton width="100%" />
                <Skeleton width="100%" />
                <Skeleton width="130px" />
              </div>
            </div>
          </div>
        </div>
        <div className="FullCruiseDetailsRight">
          <ShareButton link="" modalAlign="end" modalSide="top" />
          <div className="MoreDatesModule">
            <div className="selectYourVoyageHeading">
              <Skeleton width="90%" />
            </div>
            <div className="totalSailingsCount">
              <Skeleton width="90%" />
            </div>
            <div className="monthTitle">
              <Skeleton inDarkBg width="60%" />
            </div>
            <Row />
            <div className="monthTitle">
              <Skeleton inDarkBg width="60%" />
            </div>
            <Row />
            <div className="cardSeparator"></div>
            <Row />
            <div className="monthTitle">
              <Skeleton inDarkBg width="60%" />
            </div>
            <Row />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullCruiseDetailsSkeleton;
